<template>
    <c-dialog ref="dialog" height="650" width="800" @resolve="editHandle">
        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>
            <c-form-item label="采购供应商名称" required>
                <c-input name="supplier_name"></c-input>
            </c-form-item>
            <c-form-item label="评级">
                <c-radio-group name="rating" :options="ratingOptions"></c-radio-group>
            </c-form-item>
            <c-form-item label="联系人" tip="一个供应商可关联多个联系人（即类型为“供应商联系人”的系统用户），一个用户只能关联一个供应商，如果用户原先关联了其他供应商，则提交后，原先的关联关系将被解除">
                <c-select name="supplier_contact_user_ids" async @search="searchUser" :value-data="selectedUser" multiple></c-select>
            </c-form-item>
            <c-form-item label="联系电话">
                <c-input name="contact_phone"></c-input>
            </c-form-item>
            <c-form-item label="备注">
                <c-input type="textarea" name="remark" maxlength="200"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    name: 'purchaseSupplierEdit',

    data() {
        return {
            ratingOptions: [
                {name: 'A', value: 'A'},
                {name: 'B', value: 'B'},
                {name: 'C', value: 'C'}
            ],
            selectedUser: []
        }
    },

    methods: {

        /*******搜索用户*****************/
        searchUser(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'SYSUSER',
                    user_type:2,            //仅查询【供应商联系人】
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*********打开编辑框，初始化**********/
        open(data) {
            this._editState = !!data;

            this.$refs.form.clear();
            if (data) {
                this.$refs.form.set(data);
                //查询部门详情
                this.request({
                    url: '/purchase/supplier/detail',
                    data: {
                        id: data.id
                    },
                    success: data => {
                        this.$refs.form.set(data.supplier);
                        this.selectedUser = (data.contact_user_list||[]).map(item => {
                            return {
                                name:item.user_realname,
                                value:item.id
                            }
                        });
                    }
                })
            }
            //填充form表单
            this.$refs.dialog.open({
                title: data ? '编辑采购供应商' : '创建采购供应商'
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: this._editState ? '/purchase/supplier/edit' : '/purchase/supplier/add',
                rule: {
                    supplier_name: '请输入采购供应商名称'
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '提交成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>